import CreateDataRoomProvider from './CreateDataRoom.provider';

export default CreateDataRoomProvider;